import React from "react";
import { Link, useLocation } from "react-router-dom";
import { resetCookieConsent } from "./CookieBanner";
import ThemeToggle from "./ThemeToggle";

export default function Footer() {
  const location = useLocation();
  if (new URLSearchParams(location.search).get("embed") === "1") return null;
  return (
    <footer className="mt-16 border-t border-zinc-100 bg-white dark:border-zinc-800 dark:bg-zinc-900" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-zinc-500 dark:text-zinc-400">
        <div>
          © {new Date().getFullYear()} Prenotoo · Gestito da Assitec snc di Gatto L. &amp; Fusco F. · P.IVA 03749240754 · REA LE-242456
          <span className="hidden md:inline"> · Hosted in 🇪🇺 Frankfurt (DE)</span>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          <Link to="/privacy" className="hover:text-zinc-900 dark:hover:text-zinc-100" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/cookie-policy" className="hover:text-zinc-900 dark:hover:text-zinc-100" data-testid="footer-cookie">Cookie Policy</Link>
          <Link to="/terms" className="hover:text-zinc-900 dark:hover:text-zinc-100" data-testid="footer-terms">Termini di Servizio</Link>
          <Link to="/dpa" className="hover:text-zinc-900 dark:hover:text-zinc-100" data-testid="footer-dpa">DPA</Link>
          <Link to="/status" className="hover:text-zinc-900 dark:hover:text-zinc-100" data-testid="footer-status">Status</Link>
          <button
            type="button"
            onClick={resetCookieConsent}
            className="hover:text-zinc-900 underline-offset-4 hover:underline dark:hover:text-zinc-100"
            data-testid="footer-cookie-prefs"
          >
            Gestisci cookie
          </button>
          <a href="mailto:info@assiteclecce.it" className="hover:text-zinc-900 dark:hover:text-zinc-100">Contatti</a>
          <ThemeToggle />
        </nav>
      </div>
    </footer>
  );
}
